<div class="flex h-screen bg-dark-bg overflow-hidden">
  <!-- Desktop sidebar — hidden below md -->
  <app-sidebar class="hidden md:flex" />

  <!-- Main content area -->
  <div class="flex flex-col flex-1 min-w-0">
    <!-- Mobile header — visible below md -->
    <header class="flex md:hidden items-center h-14 px-4 border-b border-dark-border">
      <button
        #hamburgerBtn
        type="button"
        class="text-dark-text-secondary focus:outline-none focus:ring-2 focus:ring-dark-accent rounded p-1"
        (click)="openDrawer()"
        aria-label="Open navigation"
        [attr.aria-expanded]="drawerOpen()"
        aria-controls="mobile-nav-drawer"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5" aria-hidden="true">
          <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
        </svg>
      </button>
    </header>

    <app-verification-banner />

    <main class="flex-1 overflow-y-auto">
      <router-outlet />
    </main>
  </div>

  <!-- Mobile drawer -->
  <app-mobile-drawer
    [open]="drawerOpen()"
    (closeRequested)="closeDrawer()"
  />
</div>
